import type { ListingSort } from '../../listingPaging';
import type { RowSelection } from '@/components/ui/hooks/use-row-selection';

export interface TableActionBarProps {
  onActionClick: (value: string) => void;
  isProperty: boolean;
  isCardView: boolean;
  isOrderCart?: boolean;
  onTableSort: (key: string | undefined, asc: boolean | undefined) => void;
  /** Sort to open with, for a list restoring where the user left it (DV-3455). Matched to an
   *  option by key; one the menu doesn't offer leaves the default. Read once at mount. */
  initialSort?: ListingSort | null;
  onClearCart?: () => void;
  onCheckboxClearAction?: () => void;
  /** Row-selection contract from `useRowSelection`, owned by the parent list page. */
  selection: RowSelection;
}

export enum LayoutTypes {
  LIST = 'list',
  CARD = 'card'
}
